import 'rxjs/add/observable/of';
import 'rxjs/add/operator/debounceTime';
import { Component, Input, NgZone, OnDestroy, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from "@angular/animations";
import { Location } from '@angular/common';
import { ThingService } from '@core/thing/thing.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ThingsResult } from '@providers/thing.provider';
import { GroupEditComponent } from './groupEdit.component';
import { DeletGroupComponent } from '../delete/deleteGroup.component';
import { KngDrawerService } from '@layout/kingswell/kingswell';
import { ThingProvider } from '@providers/thing.provider';
import { ParkProvider } from '@providers/park.provider';

@Component({
  selector: 'things-group-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.less'],
  animations: [
    trigger('showEditThingAnimation', [
      state('*', style({
      })),
      state('void', style({
        transform: 'translate3d(-200px, 0, 0)'
      })),
      transition('void <=> *', animate('200ms ease-in-out')),
    ])
  ]
})
export class RestroomGroupListComponent implements OnInit, OnDestroy {

  public things = [];

  filteredThings = [];
  // dictionary where key is the group and value is an array
  groupedThings = {};
  groupNames = [];
  searchText = '';
  types = [{ label: 'All Restrooms', name: '' }, { label: 'Men\'s Restroom', name: 'RESTROOM_MALE' }, { label: 'Woman\'s Restroom', name: 'RESTROOM_FEMALE' }];
  selectedType = '';

  defaultAreaId: string;
  areaId = '';
  area = {};

  showDetails: boolean = true;
  thingsResult: ThingsResult;
  isClosed: boolean = true;
  continuationToken = '';
  showStickyHeader: boolean = false;

  constructor(private _location: Location, private thingService: ThingService, private route: ActivatedRoute,
    private kngDrawer: KngDrawerService, private thingProvider: ThingProvider, private areaProvider: ParkProvider) {
    this.defaultAreaId = route.snapshot.params['areaId'];
    this.areaId = this.defaultAreaId + "";
    // init unGrouped things here so it doesn't throw an error in the console
    this.groupedThings['unGrouped'] = [];
    this.areaProvider.getArea(this.areaId).toPromise().then(area => {
      this.area = area;
      console.log('area: ', area);
      this.isClosed = this._isClosed(area);
    });
  }

  _isClosed(area):boolean {
    // closedTime comes in as hh:mm AM/PM format
    let closingTime = parseInt(area.closingTime.split(' ')[0].split(':')[0]) + parseInt(area.closingTime.split(' ')[0].split(':')[1]) / 60;
    area.closingTime.split(' ')[1] == 'PM' ? closingTime += 12 : '';
    let openingTime = new Date(area.openDateTime);
    let currentTime = new Date();

    if (currentTime >= openingTime && currentTime.getHours() + currentTime.getMinutes() / 60  <= closingTime) {
      return false;
    } else {
      return true;
    }
  }

  _createChunks(items: Array<any>): Array<any> {
    // break up items into chunks of 5 for every column, 3 columns in a chunk
    var chunk = [];
    items.forEach((item, index )=> {
      // init a new chunk every 15 items
      index % 15 === 0 ? chunk.push([]) : '';
      // init a sub array every 5 items
      index % 5 === 0 ? chunk[Math.floor(index / 15)].push([]) : '';
      chunk[Math.floor(index / 15)][Math.floor((index % 15) / 5)].push(item);
    });
    return chunk;
  }

  ngOnInit() {
    this.refreshThings();
  }

  refreshThings() {
    //this.initThings();

    this.thingService.reloadThingDataLazy();

    this.continuationToken = this.getContinuationToken();

    this.thingService.getThings({
      areas: this.areaId,
      types: ['RESTROOM_MALE', 'RESTROOM_FEMALE'],
      status: '',
      continuationToken: this.continuationToken
    }).then(things => {
      this.things = things.results;
      this.applyFilters();
    });
  }

  applyFilters() {
    this.filteredThings = this.things.filter(thing => {
      return ((thing.name.toLowerCase().indexOf(this.searchText.toLowerCase()) != -1) &&
        (this.selectedType == '' || this.selectedType == thing.type))
    });
    this.filteredThings = this.filteredThings.sort((a, b) => {
      let aName = a.name ? a.name.toLowerCase() : a.thingId;
      let bName = b.name ? b.name.toLowerCase() : b.thingId;

      if (aName < bName) return -1;
      if (aName > bName) return 1;

      return 0;
    });
    this.filteredThings.forEach(thing => { thing.name = thing.name.toUpperCase() });
    this.groupThings();
    this.viewThings();
    console.log('testing new grouping funtion: ', this._createChunks(this.filteredThings));
  }

  groupThings() {
    //init groupedThings
    for (var group in this.groupedThings) {
      this.groupedThings[group] = [];
    }
    this.filteredThings.forEach(thing => {
      if (!thing.groupName)
        this.groupedThings['unGrouped'].push(thing);
      else {
        if (!this.groupedThings[thing.groupName])
          this.groupedThings[thing.groupName] = [];
        this.groupedThings[thing.groupName].push(thing);
      }
    });
  }

  /**
   * transforms groupedThings dictionary to make it more UI friendly to display.
   * for each group take the array and transform it to a 5 x N matrix.
   */
  viewThings() {
    this.groupNames = [];
    for (var group in this.groupedThings) {
      // var temp = [];
      // for (var i = 0; i < 5; i++)
      //   temp[i] = [];
      // for (i = 0; i < this.groupedThings[group].length; i++) {
      //   temp[i % 5][Math.floor(i / 5)] = this.groupedThings[group][i];
      // }
      // console.log('_createChunks(',group,'):', this._createChunks(this.groupedThings[group]));
      this.groupedThings[group] = this._createChunks(this.groupedThings[group]);
      this.groupNames.push(group);
    }
    // console.log('viewThings()\ngroupedThings: ', this.groupedThings, '\ngroupNames: ', this.groupNames);
  }

  search(event) {
    this.searchText = event;
    this.applyFilters();
  }

  toogleDetails(event) {
    this.showDetails = !this.showDetails;
  }

  getNumberOfThings(name) {
    return this.filteredThings.filter(thing => {
      return thing.groupName == name;
    }).length;
  }

  openEditModal(event, group) {
    event.preventDefault();
    let drawer = this.kngDrawer.launch(GroupEditComponent, {
      windowClass: "kng-drawer-threshold"
    });
    drawer.componentInstance.groupName = group;
    drawer.componentInstance.things = this.things;

    drawer.result
      .then(res => {
        if (res == 'delete') {
          console.log(res);
          let deleteDrawer = this.kngDrawer.launch(DeletGroupComponent, {
            windowClass: "alert-moal-content"
          });
          deleteDrawer.componentInstance.groupName = group;

          deleteDrawer.result
            .then(confirm => {
              if (confirm) {
                this.things.forEach((thing, index) => {
                  if (thing.groupName && thing.groupName == confirm) {
                    thing.groupName = null;
                    this.thingProvider.updateThing(thing)
                      .then(res => {
                        this.refreshThings();
                      })
                      .catch();
                  }
                });
                //this.refreshThings();
              }
              else {
                console.log('not deleting group');
              }
            });
        } else {
          console.log('saving?');
          console.log(res);
          this.refreshThings();
        }
      });
  }

  ngOnDestroy() {

  }

  changeTypes(type) {
    this.selectedType = type;
    this.applyFilters();
  }

  close() {
    this._location.back();
  }

  isOpen() {
    return true;
  }

  onContentScroll(event) {
    //console.log('on content scroll', event);
  }

  getAreaLabel() {
    return this.things[0] && this.things[0].areaName ? this.things[0].areaName : '';
  }

  getContinuationToken() {
    if (this.thingsResult) {
      return this.thingsResult["nextContinuationToken"];
    }
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/things/restroomGroup/list/list.component.ts